import React, { useState } from 'react'
import { DataTable, DataTableRow, Divider, Expander, ExpanderContent, ExpanderHeader, H5 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function OdmRecordErrors({ errors }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)

  return (
    <>
      <Divider marginY="nano" />
      <Expander open={open} setOpen={setOpen}>
        <ExpanderHeader>
          <H5>{t('odm.errors', 'Errors')}</H5>
        </ExpanderHeader>
        <ExpanderContent>
          <Divider marginY="nano" />
          {errors && (
            <DataTable
              columns={[
                { label: t('odm.error.message', 'Error / Information Messages'), size: 'md' },
                { label: t('type', 'Type'), size: 'xs' },
                { label: t('status.label', 'Status'), size: 'xs' },
                { label: t('odm.error.info', 'Invalid Information'), size: 'lg' },
                { label: t('odm.error.createDate', 'Date Created'), size: 'md' },
              ]}
            >
              {errors.map((error) => {
                return (
                  <DataTableRow
                    key={error.id}
                    column1={error.message}
                    column2={error.type}
                    column3={error.status}
                    column4={error.invalidInfo}
                    column5={error.created}
                  />
                )
              })}
            </DataTable>
          )}
          {!errors || (errors.length <= 0 && <p>{t('odm.noErrors', 'No Errors')}</p>)}
          <Divider marginY="nano" />
        </ExpanderContent>
      </Expander>
    </>
  )
}
